import { atom, useAtom } from "jotai"

function createResettingAtom<TValue>(initialValue: TValue) {
  const valueAtom = atom(initialValue)
  valueAtom.onMount = (set) => {
    return () => {
      set(initialValue)
    }
  }

  return valueAtom
}

export const durationAtom = createResettingAtom(0)
export const currentTimeAtom = createResettingAtom(0)
export const isPlayingAtom = createResettingAtom(false)
export const isBufferingAtom = createResettingAtom(false)

export const useDuration = () => useAtom(durationAtom)
export const useCurrentTime = () => useAtom(currentTimeAtom)
export const useIsPlaying = () => useAtom(isPlayingAtom)
export const useIsBuffering = () => useAtom(isBufferingAtom)
